import React from 'react';
import './index.scss';
import decorSunIcon from '../../assets/img/logos-image-main-sun.png';
import { useTranslation } from 'react-i18next';

const BasicHomePage = () => {
  const { t } = useTranslation();

  return (
    <div className="home-page-basic  container">
      <div className="welcome">
        <div className="welcome-content">
          <h1>{t('welcomeToLogos')}</h1>

          <p>{t('welcomeDescription')}</p>
        </div>
        <div className="welcome-image">
          <img src={decorSunIcon} alt="Logos" />
        </div>
      </div>
    </div>
  );
};

export default BasicHomePage;
